// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OqILx","clinicsSelect":"styles_clinicsSelect__2Zk7X"};